import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { LoadingScreen, PrivateRoute } from 'components/Atoms';
import { PrivateLayout } from 'components/Templates';
import renderRoutes from 'routers/render';
import * as routeName from 'routers/route-name';

import { selectLanguage } from 'states/common/selectors';

import messages_vi from 'translations/vi.json';
import messages_en from 'translations/en.json';
import { useSelector } from 'react-redux';

import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import queryClient from 'utilities/queryClient';
import Maintenance from 'components/Pages/Maintenance';
import { useBeforeRender } from 'hooks/useBeforeRender';

const messages = {
  vi: messages_vi,
  en: messages_en,
};

const languageBrowser = navigator.language.split(/[-_]/)[0];
const languageLocal = localStorage.getItem('language');

function App() {
  // Handle subdomain
  const languageLo = useSelector(selectLanguage());
  const language = languageLo || languageBrowser;
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE;

  if (isMaintenanceMode) {
    return <Maintenance />;
  }

  useBeforeRender(() => {
    window.addEventListener('error', (e) => {
      if (e) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        );

        if (resizeObserverErr)
          resizeObserverErr.className = 'hide-resize-observer';
        if (resizeObserverErrDiv)
          resizeObserverErrDiv.className = 'hide-resize-observer';
      }
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <IntlProvider locale={language} messages={messages[language]}>
        <Router>
          <Suspense fallback={<LoadingScreen />}>
            <Switch>
              {renderRoutes()}
              <PrivateRoute path="/" name={routeName.HOME}>
                <PrivateLayout />
              </PrivateRoute>
            </Switch>
          </Suspense>
          <ReactQueryDevtools initialIsOpen={false} />
        </Router>
      </IntlProvider>
    </QueryClientProvider>
  );
}

export default App;
